<template>
  <div class="text-left" :title="getLabel">
    <v-menu v-model="menuModel" offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <div :class="['multiple-select-btn', widthcss]" v-on="on" >
          <label>{{ getLabel }}</label>
          <v-icon>mdi-menu-down</v-icon>
        </div>
      </template>
      <v-list
        class="drop-down-list multi-drop-list"
        v-if="selectedItems && selectedItems.length"
        ref="scroll-top"
        id="scroller"
      >
        <v-list-item v-if="!showCoorCenter">
          <v-list-item-title>
            <div class="check-opction-css check-cust">
              <v-checkbox
                id="all"
                v-model="selectAll"
                @change="changeAll"
                hide-details
               
              ></v-checkbox>
              <span  @click="clickAllText" class="multi-text">{{
                allText > "" ? allText : "All"
              }}</span>
            </div>
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-for="(item, index) in selectedItems" :key="index">
          <v-list-item-title>
            <div v-if="item" class="check-opction-css check-cust">
              <v-checkbox
                v-model="item.checked"
                :disabled="item.disabled"
                @change="onItemChange"
                hide-details
              ></v-checkbox>
              <span @click="onItemClick(item)" class="multi-text">{{
                item.text
              }}</span>
            </div>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "MultiSelect",
  props: [
    "items",
    "label",
    "onChange",
    "info",
    "widthcss",
    "menuValue",
    "allText",
    "noText",
    "isShowNo",
    "showCoorCenter",
	  "persistentStatus",
    "updateScrollerFlag"
  ],
  mounted() {
    if (this.menuValue) {
      this.menuModel = this.menuValue.value;
    }
    this.scrollerFlag = this.updateScrollerFlag;
  },
  data() {
    return {
      selectAll: false,
      selectedItems: [],
      menuModel: false,
      SelectNO: false,
      scrollerFlag: null
    };
  },
  methods: {
    onItemChange() {
      this.selectAll = this.isAllSelected;
      this.SelectNO = false;

      this.sendSelectedItems();
    },
    changeAll() {
      this.selectedItems = this.selectedItems.map((x) => {
        x.checked = this.selectAll;
        return x;
      });
      this.SelectNO = false;
      this.sendSelectedItems();
    },
    nothingSelectChange() {
      this.selectedItems = this.selectedItems.map((x) => {
        x.checked = false;
        return x;
      });
      this.selectAll = false;
      this.sendSelectedItems();
    },
    clickAllText() {
      this.selectAll = !this.selectAll;
      this.changeAll();
    },
    onItemClick(item) {
      this.selectedItems = this.selectedItems.map((x) => {
        if (x.value == item.value) {
          x.checked = !x.checked;
        }
        return x;
      });
      this.selectAll = this.isAllSelected;
      this.sendSelectedItems();
    },
    sendSelectedItems() {
      let tmpArr = [];
      this.selectedItems.map((x) => {
        if (x && x.checked && x.value) tmpArr.push(x.value);
      });

      this.onChange(tmpArr, { info: this.info });
    },
    clearAllSelection() {
      this.selectedItems = this.selectedItems.map(x=>x.checked=false)
    },
	focused() {
            this.persistentStatus(true);
        },
        blurred(e) {
            _.debounce(this.persistentStatus, 200)(false, this);
        },
		setMenuModal(){
			this.menuModel = false;

		},
    updateScroll(){
      if (this.scrollerFlag) {
        var scroller = document.getElementById("scroller");
        scroller.scrollTop = 0;
      }
      this.scrollerFlag = false;
      
   },
  },
  computed: {
    isAllSelected() {
      if (this.selectedItems && this.selectedItems.length) {
        return (
          this.selectedItems.filter((x) => x.checked).length ===
          this.selectedItems.length
        );
      }
      return false;
    },
    getLabel() {
      if (this.selectAll) {
        return this.allText > "" ? this.allText : "All";
      }
      let tmpArry = this.selectedItems
        .filter((x) => x.checked)
        .map((xx) => xx.text);
      if (tmpArry && tmpArry.length) {
        return tmpArry.join(", ");
      }
      return this.label;
    },
  },
  watch: {
    updateScrollerFlag(val){
      this.scrollerFlag = val;
    },
    items(val) {
      this.selectedItems = val;
      this.selectAll = this.isAllSelected;
    },
    menuModel(status) {
      let me = this;
      setTimeout(() => {
        me.updateScroll()
        
      }, 500);
      
		if(status && this.persistentStatus){
			this.focused()
     
		}
		else{
			if(this.persistentStatus){
			this.blurred()
			}
		}
      if (this.menuValue) {
        this.menuValue.value = status;
      }
    },
    /*selectedCenters(val)
    {
      let me = this;
       setTimeout(()=> {
            me.updateScroll();
        }, 100);
      
    },*/
  },
};
</script>
